import { render, staticRenderFns } from "./AssetStats.vue?vue&type=template&id=23aec9d9&"
import script from "./AssetStats.vue?vue&type=script&lang=js&"
export * from "./AssetStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports